/** @format */

import ResourcesIndexUI from "./resourceIndexUI/ResourcesIndexUI";
import { useGetResourcesFromSubjectQuery } from "../../app/services/subjectApi";
import { skipToken } from "@reduxjs/toolkit/query";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import React from "react";
import { useLocale } from "../../i18n/hooks";
import { useSubject } from "../subject/SubjectPage";
import { Spinner } from "react-bootstrap";
import { useAppSelector } from "../../app/hooks";
import { AvailableFilters } from "./resourceFilter/ResourcesFilter";
import { useGetUserQuery } from "../../app/services/userApi";

const ResourceIndex: React.FC<{}> = () => {
  const { subject } = useSubject();
  const locale = useLocale();
  const { data, isLoading } = useGetResourcesFromSubjectQuery(
    subject ? { code: subject.id, locale: locale } : skipToken,
  );

  const isAuthenticated =
    useAppSelector((state) => state.auth.userToken?.token) || false;
  const { data: user, isLoading: isUserLoading } = useGetUserQuery(
    isAuthenticated ? undefined : skipToken,
  );
  const isStaff = user?.role === "wjec" || user?.role === "admin";

  const defaultFilters: AvailableFilters[] = [
    "qualification",
    "spec",
    "level",
    "type",
    "cat",
    "tag",
  ];

  return isLoading || isUserLoading ? (
    <div className="position-absolute top-50 start-50 translate-middle">
      <Spinner animation="border" />
    </div>
  ) : (
    <>
      <BreadCrumb />
      <ResourcesIndexUI
        filters={
          isStaff ? [...defaultFilters, "status"] : defaultFilters
        }
        subject={subject}
        resources={data ?? []}
      />
    </>
  );
};

export default ResourceIndex;
